<template>
  <div class="home-strategic">
    <div class="container">
      <div>
        <div class="home-strategic-title">{{ $t("home.Strategic") }}</div>
      </div>
      <div class="home-strategic-line"></div>

      <div class="home-strategic-list">
        <a
          v-for="(item, index) in strategicList"
          :key="index"
          class="home-strategic-item"
          :href="item.url || undefined"
          :target="item.url ? '_blank' : undefined"
          :rel="item.url ? 'noopener noreferrer' : undefined"
          @click="onstrategicClick($event, item)"
        >
          <img class="home-strategic-img" :src="item.img" :alt="item.alt">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import strategic1 from '../../assets/home/strategic-1.png'
import strategic2 from '../../assets/home/strategic-2.png'
import strategic3 from '../../assets/home/strategic-3.png'
import strategic4 from '../../assets/home/strategic-4.png'
import strategic5 from '../../assets/home/strategic-5.png'
import strategic6 from '../../assets/home/strategic-6.png'

export default {
  name: 'Homestrategic',
  data() {
    return {
      strategicList: [
        {
          img: strategic1,
          alt: '昆仑材料',
          url: 'https://mp.weixin.qq.com/s/lLK7l6AetujgJ8Nqv4p8SQ',
        },
        {
          img: strategic3,
          alt: '腾讯量子实验室',
          url: 'https://pwmat.com/company-news-content/63',
        },
        {
          img: strategic5,
          alt: '孔皆智能',
          url: 'https://mp.weixin.qq.com/s/Dwb38mjeKTXtx0Jo8926qQ',
        },
        {
          img: strategic2,
          alt: '北京超级云计算中心',
          url: 'https://pwmat.com/company-news-content/64',
        },
        {
          img: strategic4,
          alt: '曙光智算',
          url: 'https://mp.weixin.qq.com/s/93TF0pbQXWxOBcnly-RPzQ',
        },
        {
          img: strategic6,
          alt: '海光信息',
          url: 'https://mp.weixin.qq.com/s/WpgDkwrtOQhmM1i01bSLzg',
        },
      ],
    }
  },
  methods: {
    onstrategicClick(event, item) {
      if (!item.url) {
        event.preventDefault()
      }
    },
  },
}
</script>

<style scoped>
.home-strategic {
  margin-top: 60px;
  margin-bottom: 60px;
}
.home-strategic-title {
  display: inline-block;
  font-size: 32px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(73, 145, 201, 1);
  line-height: 45px;
}
.home-strategic-line {
  margin-top: 8px;
  height: 1px;
  background: rgba(240, 240, 240, 1);
}
.home-strategic-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  gap: 16px;
  margin-top: 40px;
}
.home-strategic-item {
  flex: 0 0 calc((100% - 32px) / 3);
  min-width: 0;
  display: block;
  cursor: pointer;
  text-decoration: none;
}
.home-strategic-img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}
@media (max-width: 768px) {
  .home-strategic-list {
    gap: 12px;
  }
  .home-strategic-item {
    flex: 0 0 calc((100% - 12px) / 2);
  }
}
</style>
